import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as employeeApi from '../../lib/api/employee';

//자격증
const [
  LIST_RECORD_LICENSE,
  LIST_RECORD_LICENSE_SUCCESS,
  LIST_RECORD_LICENSE_FAILURE,
] = createRequestActionTypes('employee/LIST_RECORD_LICENSE');

export const listRecordLicense = createAction(
  LIST_RECORD_LICENSE,
  (params) => params,
);
const listRecordLicenseSaga = createRequestSaga(
  LIST_RECORD_LICENSE,
  employeeApi.getResumeByEmp,
);

const UNLOAD_RECORD_LICENSE = 'employee/UNLOAD_RECORD_LICENSE';
export const unloadRecordLicense = createAction(UNLOAD_RECORD_LICENSE);

//기술관리
const [LIST_TECH_MGT, LIST_TECH_MGT_SUCCESS, LIST_TECH_MGTE_FAILURE] =
  createRequestActionTypes('employee/LIST_TECH_MGT');

export const listTechMgts = createAction(LIST_TECH_MGT, (params) => params);
const listTechMgtsSaga = createRequestSaga(
  LIST_TECH_MGT,
  employeeApi.getResumeByEmp,
);

const UNLOAD_TECH_MGT = 'employee/UNLOAD_TECH_MGT';
export const unloadTechMgts = createAction(UNLOAD_TECH_MGT);

//상벌조항
const [
  LIST_REWARD_PUNISHMENT,
  LIST_REWARD_PUNISHMENT_SUCCESS,
  LIST_REWARD_PUNISHMENT_FAILURE,
] = createRequestActionTypes('employee/REWARD_PUNISHMENT');

export const listRewardPunishment = createAction(
  LIST_REWARD_PUNISHMENT,
  (params) => params,
);
const listRewardPunishmentSaga = createRequestSaga(
  LIST_REWARD_PUNISHMENT,
  employeeApi.getResumeByEmp,
);

const UNLOAD_REWARD_PUNISHMENT = 'employee/UNLOAD_REWARD_PUNISHMENT';
export const unloadRewardPunishment = createAction(UNLOAD_REWARD_PUNISHMENT);

//KPI
const [LIST_KPI, LIST_KPI_SUCCESS, LIST_KPI_FAILURE] =
  createRequestActionTypes('employee/LIST_KPI');

export const listKPI = createAction(LIST_KPI, (params) => params);
const listKPISaga = createRequestSaga(LIST_KPI, employeeApi.getResumeByEmp);

const UNLOAD_KPI = 'employee/UNLOAD_KPI';
export const unloadKPI = createAction(UNLOAD_KPI);

//RNR
const [LIST_RNR, LIST_RNR_SUCCESS, LIST_RNR_FAILURE] =
  createRequestActionTypes('employee/LIST_RNR');

export const listRNR = createAction(LIST_RNR, (params) => params);
const listRNRSaga = createRequestSaga(LIST_RNR, employeeApi.getResumeByEmp);

const UNLOAD_RNR = 'employee/UNLOAD_RNR';
export const unloadRNR = createAction(UNLOAD_RNR);

//면담
const [LIST_COUNSEL, LIST_COUNSEL_SUCCESS, LIST_COUNSEL_FAILURE] =
  createRequestActionTypes('employee/LIST_COUNSEL');

export const listCounsel = createAction(LIST_COUNSEL, (params) => params);
const listCounselSaga = createRequestSaga(
  LIST_COUNSEL,
  employeeApi.getResumeByEmp,
);

const UNLOAD_COUNSEL = 'employee/UNLOAD_COUNSEL';
export const unloadCounsel = createAction(UNLOAD_COUNSEL);

export function* employeeResumeSaga() {
  yield takeLatest(LIST_RECORD_LICENSE, listRecordLicenseSaga);
  yield takeLatest(LIST_TECH_MGT, listTechMgtsSaga);
  yield takeLatest(LIST_REWARD_PUNISHMENT, listRewardPunishmentSaga);
  yield takeLatest(LIST_KPI, listKPISaga);
  yield takeLatest(LIST_RNR, listRNRSaga);
  yield takeLatest(LIST_COUNSEL, listCounselSaga);
}

const initialState = {
  recordLicense: null,
  recordLicenseError: null,
  techmgts: null,
  techmgtsError: null,
  rewardPunishments: null,
  rewardPunishmentsError: null,
  kpis: null,
  kpisError: null,
  rnrs: null,
  rnrsError: null,
  counsels: null,
  counselsError: null,
};

const employeeResume = handleActions(
  {
    [LIST_RECORD_LICENSE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      recordLicense: data.list.map((license) => ({
        id: license.infoUuid,
        infoUuid: license.infoUuid,
        usrUuid: license.usrUuid,
        infoTyp: license.infoTyp,
        attrVal1: license.attrVal1,
        attrVal2: license.attrVal2,
        attrVal3: license.attrVal3,
        attrVal4: license.attrVal4,
        attrVal5: license.attrVal5,
        fileUuid: license.fileUuid,
        fileNm:license.fileNm,
        fileUrl: license.fileUrl,
        crtNm: license.crtNm,
        crtDt: license.crtDt,
        cngNm: license.cngNm,
        cngDt: license.cngDt,
      })),
      error: null,
    }),
    [LIST_RECORD_LICENSE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      recordLicenseError: error,
    }),
    [UNLOAD_RECORD_LICENSE]: (state) => ({
      ...state,
      recordLicense: null,
      recordLicenseError: null,
    }),
    [LIST_TECH_MGT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techmgts: data.list.map((tech) => ({
        id: tech.infoUuid,
        infoUuid: tech.infoUuid,
        usrUuid: tech.usrUuid,
        infoTyp: tech.infoTyp,
        attrVal1: tech.attrVal1,
        attrVal2: tech.attrVal2,
        attrVal3: tech.attrVal3,
        attrVal4: tech.attrVal4,
        crtNm: tech.crtNm,
        crtDt: tech.crtDt,
        cngNm: tech.cngNm,
        cngDt: tech.cngDt,
      })),
      techmgtsError: null,
    }),
    [LIST_TECH_MGTE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      techmgtsError: error,
    }),
    [UNLOAD_TECH_MGT]: (state) => ({
      ...state,
      techmgts: null,
      techmgtsError: null,
    }),

    [LIST_REWARD_PUNISHMENT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      rewardPunishments: data.list.map((rp) => ({
        id: rp.infoUuid,
        infoUuid: rp.infoUuid,
        usrUuid: rp.usrUuid,
        infoTyp: rp.infoTyp,
        attrVal1: rp.attrVal1,
        attrVal2: rp.attrVal2,
        attrVal3: rp.attrVal3,
        attrVal4: rp.attrVal4,
        attrVal5: rp.attrVal5,
        attrVal6: rp.attrVal6,
        crtNm: rp.crtNm,
        crtDt: rp.crtDt,
        cngNm: rp.cngNm,
        cngDt: rp.cngDt,
      })),
      rewardPunishmentsError: null,
    }),
    [LIST_REWARD_PUNISHMENT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      rewardPunishmentsError: error,
    }),
    [UNLOAD_REWARD_PUNISHMENT]: (state) => ({
      ...state,
      rewardPunishments: null,
      rewardPunishmentsError: null,
    }),

    [LIST_KPI_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      kpis: data.list.map((kpi) => ({
        id: kpi.infoUuid,
        infoUuid: kpi.infoUuid,
        usrUuid: kpi.usrUuid,
        infoTyp: kpi.infoTyp,
        attrVal1: kpi.attrVal1,
        attrVal2: kpi.attrVal2,
        attrVal3: kpi.attrVal3,
        attrVal4: kpi.attrVal4,
        attrVal5: kpi.attrVal5,
        crtNm: kpi.crtNm,
        crtDt: kpi.crtDt,
        cngNm: kpi.cngNm,
        cngDt: kpi.cngDt,
      })),
      kpisError: null,
    }),
    [LIST_KPI_FAILURE]: (state, { payload: error }) => ({
      ...state,
      kpisError: error,
    }),
    [UNLOAD_KPI]: (state) => ({
      ...state,
      kpis: null,
      kpisError: null,
    }),

    [LIST_RNR_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      rnrs: data.list.map((rnr) => ({
        id: rnr.infoUuid,
        infoUuid: rnr.infoUuid,
        usrUuid: rnr.usrUuid,
        infoTyp: rnr.infoTyp,
        attrVal1: rnr.attrVal1,
        attrVal2: rnr.attrVal2,
        attrVal3: rnr.attrVal3,
        crtNm: rnr.crtNm,
        crtDt: rnr.crtDt,
        cngNm: rnr.cngNm,
        cngDt: rnr.cngDt,
      })),
      rnrsError: null,
    }),
    [LIST_RNR_FAILURE]: (state, { payload: error }) => ({
      ...state,
      rnrsError: error,
    }),
    [UNLOAD_RNR]: (state) => ({
      ...state,
      rnrs: null,
      rnrsError: null,
    }),

    [LIST_COUNSEL_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      counsels: data.list.map((rp) => ({
        id: rp.infoUuid,
        infoUuid: rp.infoUuid,
        usrUuid: rp.usrUuid,
        infoTyp: rp.infoTyp,
        attrVal1: rp.attrVal1,
        attrVal2: rp.attrVal2,
        attrVal3: rp.attrVal3,
        crtNm: rp.crtNm,
        crtDt: rp.crtDt,
        cngNm: rp.cngNm,
        cngDt: rp.cngDt,
      })),
      counselsError: null,
    }),
    [LIST_COUNSEL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      counselsError: error,
    }),
    [UNLOAD_COUNSEL]: (state) => ({
      ...state,
      counsels: null,
      counselsError: null,
    }),
  },
  initialState,
);

export default employeeResume;
